export const storageService = {
  session: {
    get(item: string, defaultValue: any = undefined): any {
      return sessionStorage.getItem(item) || defaultValue;
    },
    set(key: string, value: any) {
      if (value === undefined || value === null) {
        return;
      }

      sessionStorage.setItem(key, value);
    },
    setObject(key: string, value: unknown) {
      if (value) { this.set(key, JSON.stringify(value)); }
    },
    getObject(item: string, defaultValue: any = undefined): any {
      const strItem: string | undefined = this.get(item, defaultValue);

      if (strItem) { return JSON.parse(strItem); }

      return null;
    },
    remove(key: string) {
      sessionStorage.removeItem(key);
    },
    clear() {
      sessionStorage.clear();
    },
    length() {
      return sessionStorage.length;
    },
  },
};
